// language.js
import {
  SET_USER_STATUS,
  UPDATE_USER_STATUS,
  SET_USER_LOGOUT,
} from "constants/system";

const initialState = false;

const language = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_STATUS: {
      return state;
    }
    case UPDATE_USER_STATUS: {
      return action.payload;
    }
    case SET_USER_LOGOUT: {
      return 1;
    }
    default:
      return state;
  }
};

export default language;
